module.exports = __webpack_public_path__ + "static/media/poicon33.508269ec.svg";